module.exports = __webpack_public_path__ + "static/media/arbitrationNoticeBtn.e8e36bb4.png";